module.exports = __webpack_public_path__ + "img/il_banner.cdc6c736.png";